import { useQuery } from "@tanstack/react-query";
import { getGroupedExpenses } from "@/features/vouchers/services/groupedExpense.service";
import { GroupedExpensesResponse } from "@/features/vouchers/types/groupedExpense.type";

type UseGroupedExpensesParams = {
  payment_id: string
  enabled?: boolean
};

export const useGroupedExpenses = ({ payment_id, enabled = true }: UseGroupedExpensesParams) => {
  return useQuery<GroupedExpensesResponse>({
    queryKey: ["grouped-expenses", payment_id],
    queryFn: () => getGroupedExpenses({ payment_id }),
    enabled: enabled && !!payment_id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
